import { getNonLinkedItemsClient } from './getNonLinkedItemsClient'

export const client = getNonLinkedItemsClient()
